const api = 'https://api.lalie-landry.com'

const config = {
  siteName: 'Lalie Landry',
  apiBaseUrl: api,
  slideImageBaseUrl: api + '/upload/slides/' ,
  serieImageBaseUrl: api + '/upload/series/',
  novelImageBaseUrl: api + '/upload/novels/',
  eventImageBaseUrl: api + '/upload/events/',
  productImageBaseUrl: api + '/upload/products/',
  contactEmail: 'lalie@lalie-landry.com',
  contactMail: 'Au-delà du miroir éditions,<br/>110 avenue de Clichy,<br/> 75017 Paris,<br/> à l\'attention de Lalie Landry',
  bddTrueValue: 1,
  bddFalseValue: 0,
  stripePublicKey: "pk_live_51SH11l3OTstV4z7rjn6rGZp6DE0Bh68bvbdKrqwXTPDqQ9h2CjyR3sUslvPV3mIgQbztpOJpckUA3vFpSSPcyFKD00pPhQQw1i",
  // stripePublicKey: "pk_test_51SH1273DrfSe3HS4xWHchiv4cb37SK5R7kHSyaIlcHFuO1iuHZjVczeVPBpokgC5aPxDzybM59NzekJTNyFTzokR00itIbnJQ8",
}

export default config